import Image from 'next/image';

/** Blur-up loading, borrowed from how Berenjak handles its photography. */
export function BlurUpImage({
  src,
  alt,
  width,
  height,
  sizes,
  className = '',
  priority = false,
}: {
  src: string;
  alt: string;
  width: number;
  height: number;
  /** How wide the image renders, per breakpoint, so phones get the small file. */
  sizes: string;
  className?: string;
  priority?: boolean;
}) {
  return (
    <Image
      src={src}
      alt={alt}
      width={width}
      height={height}
      sizes={sizes}
      priority={priority}
      // The one above-the-fold photograph is the page's largest paint; tell the
      // browser so rather than leave it to guess from document order.
      fetchPriority={priority ? 'high' : undefined}
      placeholder="blur"
      blurDataURL="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='5'%3E%3Crect width='8' height='5' fill='%2333190f'/%3E%3C/svg%3E"
      className={className}
    />
  );
}
